import PlatformError from "../PlatformError";

export default new PlatformError(
  "WARN",
  "You have previously failed this study, please use the original link to start from the beginning.",
  "Warning",
  "User attempted to resume a failed study",
  "app.error.previousfail"
);
